// @ts-nocheck
/**
 * 确认操作 Hook - 统一封装删除、取消等危险操作的确认弹窗
 */

import { Modal } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { recordOperation } from '../utils/operationLog'

interface ConfirmOptions {
  title: string
  content: string
  okText?: string
  cancelText?: string
  okType?: 'primary' | 'danger'
  module?: string
  action?: string
  targetName?: string
  onOk: () => void | Promise<void>
}

/**
 * 危险操作确认弹窗
 * 确认后自动记录操作日志
 */
export const confirmDanger = (options: ConfirmOptions): void => {
  const {
    title,
    content,
    okText = '确认',
    cancelText = '取消',
    okType = 'danger',
    module = '系统操作',
    action = '删除',
    targetName = '',
    onOk,
  } = options

  Modal.confirm({
    title,
    icon: <ExclamationCircleOutlined />,
    content,
    okText,
    cancelText,
    okType,
    onOk: async () => {
      try {
        await onOk()
        // 操作成功后记录日志
        recordOperation(module, action, targetName, content)
      } catch (error) {
        // 错误已在 request 拦截器中处理
      }
    },
  })
}

/**
 * 删除确认（快捷方法）
 */
export const confirmDelete = (
  targetName: string,
  module: string,
  onConfirm: () => void | Promise<void>,
  extraContent?: string
): void => {
  confirmDanger({
    title: '确认删除',
    content: extraContent
      ? `确定要删除「${targetName}」吗？${extraContent}`
      : `确定要删除「${targetName}」吗？此操作不可恢复。`,
    okText: '确认删除',
    okType: 'danger',
    module,
    action: '删除',
    targetName,
    onOk: onConfirm,
  })
}

/**
 * 取消确认（快捷方法）
 */
export const confirmCancel = (
  targetName: string,
  module: string,
  onConfirm: () => void | Promise<void>
): void => {
  confirmDanger({
    title: '确认取消',
    content: `确定要取消「${targetName}」吗？`,
    okText: '确认取消',
    okType: 'danger',
    module,
    action: '取消',
    targetName,
    onOk: onConfirm,
  })
}

/**
 * 状态变更确认
 */
export const confirmStatusChange = (
  targetName: string,
  newStatus: boolean,
  module: string,
  onConfirm: () => void | Promise<void>
): void => {
  confirmDanger({
    title: newStatus ? '确认启用' : '确认禁用',
    content: `确定要${newStatus ? '启用' : '禁用'}「${targetName}」吗？`,
    okText: newStatus ? '确认启用' : '确认禁用',
    okType: 'primary',
    module,
    action: newStatus ? '启用' : '禁用',
    targetName,
    onOk: onConfirm,
  })
}
